// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChannelNavVerticalDivider: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 1 26" width={width} height={height}>
            <path fill="currentColor" d="M0 25.5V.5h1v25z" />
        </svg>
    );
};

export default React.memo(ChannelNavVerticalDivider);
